var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layer",
    { staticClass: "opt_more_g", attrs: { name: "listNum" } },
    [
      _c(
        "div",
        { staticClass: "box_opt_menu list_num_type" },
        _vm._l(_vm.listNums, function (listNum) {
          return _c("div", { staticClass: "menu_item" }, [
            _c(
              "a",
              {
                staticClass: "link_menu",
                attrs: { href: "javascript:" },
                on: {
                  click: function ($event) {
                    return _vm.callback(listNum)
                  },
                },
              },
              [_vm._v(_vm._s(listNum) + "개")]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }